import { CheckCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';

import links from '@src/constants/links.json';
import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

const LocationAlertSuccessful = () => {
  const onOk = () => {
    window.location.href = links.operonda;
  };

  return (
    <div className={styles.locationAlertSuccessful}>
      <div className={styles.scrollArea}>
        <div className={styles.successBody}>
          <CheckCircleFilled className={styles.successIcon} aria-hidden />
          <div className={styles.copyBlock}>
            <p className={styles.successTitle}>
              <IntlMessages id="location.alert.message" />
            </p>
            <p className={styles.successSubtitle}>
              <IntlMessages id="location.alert.message.thanks" />
            </p>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button block className={styles.okButton} type="primary" size="large" onClick={onOk}>
          <IntlMessages id="button.ok" />
        </Button>
      </div>
    </div>
  );
};

export default LocationAlertSuccessful;
